<!-- Card contenedora -->
<div class="payment-card">

  <!-- Ticket dentro de la card -->
  <div class="ticket-wrapper">

    <!-- Header del ticket -->
    <div class="ticket-header">
      <div class="header-content">
        <h2 class="ticket-title">Confirmación de Pago</h2>
        <p class="ticket-subtitle">Shinkansen Transfer</p>
      </div>
    </div>

    <!-- Línea punteada superior -->
    <div class="ticket-divider"></div>

    <!-- Cuerpo del ticket -->
    <div class="ticket-body">

      <!-- ID de Transacción -->
      <div class="ticket-row">
        <span class="row-label">ID de Transacción</span>
        <span class="row-value">#{{transaction?.id}}</span>
      </div>

      <!-- Línea punteada -->
      <div class="ticket-line"></div>

      <!-- Monto -->
      <div class="ticket-row amount-section">
        <span class="row-label">Monto a Transferir</span>
        <span class="amount-display">
          {{datosForm?.get('currency')?.value}} ${{datosForm?.get('amount')?.value | number:'1.0-0'}}
        </span>
      </div>

      <!-- Línea punteada -->
      <div class="ticket-line"></div>

      <!-- Datos del Beneficiario -->
      <div class="ticket-section">
        <h3 class="section-title">DATOS DEL BENEFICIARIO</h3>

        <div class="details-grid">
          <div class="detail-item">
            <span class="detail-label">Nombre Completo</span>
            <span class="detail-value">{{datosForm?.get('creditorName')?.value}}</span>
          </div>

          <div class="detail-item">
            <span class="detail-label">RUT</span>
            <span class="detail-value" [ngClass]="{'error-text': datosForm?.get('creditorRut')?.errors}">
              {{datosForm?.get('creditorRut')?.value}}
            </span>
            <!-- Mensaje de error del RUT -->
            <div *ngIf="datosForm?.get('creditorRut')?.errors" class="error-message">
              <mat-icon class="error-icon">error</mat-icon>
              <span *ngIf="datosForm?.get('creditorRut')?.errors?.['maxLength']">
                El RUT no puede tener más de 10 dígitos
              </span>
              <span *ngIf="datosForm?.get('creditorRut')?.errors?.['invalidDV']">
                Dígito verificador inválido
              </span>
              <span *ngIf="datosForm?.get('creditorRut')?.errors?.['invalidFormat']">
                Formato de RUT inválido
              </span>
              <span *ngIf="datosForm?.get('creditorRut')?.errors?.['required']">
                El RUT es requerido
              </span>
            </div>
          </div>

          <div class="detail-item">
            <span class="detail-label">Banco</span>
            <span class="detail-value">{{transaction?.bancoNombre}}</span>
          </div>

          <div class="detail-item">
            <span class="detail-label">Tipo de Cuenta</span>
            <span class="detail-value">{{datosForm?.get('creditorAccountTypeLabel')?.value}}</span>
          </div>

          <div class="detail-item full-width">
            <span class="detail-label">Número de Cuenta</span>
            <span class="detail-value">{{datosForm?.get('creditorAccountNumber')?.value}}</span>
          </div>

          <div class="detail-item full-width" *ngIf="datosForm?.get('creditorEmail')?.value">
            <span class="detail-label">Email</span>
            <span class="detail-value">{{datosForm?.get('creditorEmail')?.value}}</span>
          </div>
        </div>
      </div>

      <!-- Descripción y Referencia -->
      <div *ngIf="datosForm?.get('description')?.value || datosForm?.get('reference')?.value">
        <div class="ticket-line"></div>

        <div class="info-block" *ngIf="datosForm?.get('description')?.value">
          <span class="detail-label">Descripción</span>
          <span class="detail-value">{{datosForm?.get('description')?.value}}</span>
        </div>

        <div class="info-block" *ngIf="datosForm?.get('reference')?.value" style="margin-top: 0.375rem;">
          <span class="detail-label">Referencia</span>
          <span class="detail-value">{{datosForm?.get('reference')?.value}}</span>
        </div>
      </div>

      <!-- Línea punteada antes del footer -->
      <div class="ticket-line" style="margin-top: 0.75rem;"></div>

      <!-- Mensaje de advertencia -->
      <div class="ticket-warning">
        <mat-icon class="warning-icon">warning</mat-icon>
        <p class="warning-text">
          <strong>Importante:</strong> Verifique que todos los datos sean correctos antes de procesar el pago. Esta acción no se puede deshacer.
        </p>
      </div>

      <!-- Línea punteada antes de botones -->
      <div class="ticket-line" style="margin-top: 0.5rem; margin-bottom: 0.5rem;"></div>

      <!-- Botones -->
      <div class="ticket-actions">
        <button
          type="button"
          (click)="processPayout()"
          [disabled]="datosForm?.invalid"
          style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'"
          onmouseout="this.style.background='#1C593D'"
        >
          <mat-icon>check_circle</mat-icon>
          <span>Confirmar Pago</span>
        </button>
        <button
          type="button"
          (click)="close()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
          onmouseover="this.style.background='#f3f4f6'"
          onmouseout="this.style.background='white'"
        >
          <mat-icon>cancel</mat-icon>
          <span>Cancelar</span>
        </button>
      </div>

    </div>

  </div>

</div>
